class ZoomGallery extends HTMLElement {
  constructor() {
    super();
    this.activeVideos = [];

    this.zoomInBtn = this.querySelector("[data-zoom-in]");
    this.zoomOutBtn = this.querySelector("[data-zoom-out]");
    this.maxZoom = 5;

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  _initCarousel() {
    const updateCurrentSlide = () => {
      if (!this.gallerySwiper) return;

      const activeSlide =
        this.gallerySwiper.slides[this.gallerySwiper.realIndex];

      this.gallerySwiper.slides.forEach((slide) => {
        if (slide == activeSlide) {
          activeSlide.removeAttribute("aria-hidden");
          activeSlide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = null;
          });
        } else {
          slide.setAttribute("aria-hidden", "true");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = -1;
          });
        }
      });
    };

    const preselectMediaId = this.dataset.preselectMediaId;

    let initialSlide = 0;

    if (preselectMediaId != null) {
      const slides = Array.from(
        this.querySelectorAll(`.${this._prefix}__media-wrapper`),
      );

      const foundIndex = slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(preselectMediaId),
      );

      if (foundIndex >= 0) initialSlide = foundIndex;
    }

    const swiperParams = {
      modules: [this.swiperLib.Pagination],
      slidesPerView: "auto",
      initialSlide,
      speed: 400,
      watchSlidesProgress: true,
      zoom: {
        maxRatio: this.maxZoom,
        minRatio: 1,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      init: false,
      on: {
        realIndexChange: () => updateCurrentSlide(),
      },
    };

    this.gallerySwiper = new this.swiperLib.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    updateCurrentSlide();

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.nextZoomRatio = this.gallerySwiper.zoom.scale + 1;

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    this.gallerySwiper.on("zoomChange", () => {
      setTimeout(() => {
        if (this.zoomInBtn) {
          this.zoomInBtn.classList.toggle(
            "grey-out",
            this.gallerySwiper.zoom.scale >= this.maxZoom,
          );
        }

        if (this.zoomOutBtn) {
          this.zoomOutBtn.classList.toggle(
            "grey-out",
            this.gallerySwiper.zoom.scale <= 1,
          );
        }
      }, 100);
    });

    this.gallerySwiper.on("click", () => {
      if (this.gallerySwiper.zoom.scale < this.maxZoom) {
        this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
      } else {
        this.gallerySwiper.zoom.out();
      }
    });

    this.zoomInBtn?.addEventListener("click", () => {
      if (this.gallerySwiper.zoom.scale > this.maxZoom) return;
      this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
    });

    this.zoomOutBtn?.addEventListener("click", () => {
      this.gallerySwiper.zoom.out();
    });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("zoom-gallery")) {
  customElements.define("zoom-gallery", ZoomGallery);
}